import { render, staticRenderFns } from "./specialCategoryManager.vue?vue&type=template&id=826c4f5e&scoped=true"
import script from "./specialCategoryManager.vue?vue&type=script&lang=js"
export * from "./specialCategoryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826c4f5e",
  null
  
)

export default component.exports